export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/f25647d0b7e7a0d3567ee57d7dc48d74.jpg"
          alt="Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-20 py-32">
        <div className="flex items-center gap-16">
          <div className="flex-1 max-w-[700px]">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-8">
              <i className="ri-shield-check-line text-white text-sm"></i>
              <span className="text-white/90 text-sm font-medium">Trusted by 200+ Professional Firms</span>
            </div>

            <h1 className="text-7xl font-bold text-white mb-8 leading-tight" style={{ fontFamily: 'Crimson Pro, serif' }}>
              Where tradition meets intelligent systems.
            </h1>

            <p className="text-lg text-white/80 mb-12 leading-relaxed max-w-[600px]">
              GenieAiX helps established service firms modernize operations, streamline workflows, and apply AI responsibly—without compromising trust, compliance, or professionalism.
            </p>

            <div className="flex items-center gap-5">
              <a 
                href="#contact" 
                className="px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-lg hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                Book a Strategy Call
                <i className="ri-arrow-right-line"></i>
              </a>
              <a 
                href="#approach" 
                className="px-8 py-4 bg-transparent border-2 border-white text-white text-base font-semibold rounded-lg hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Explore Our Approach
              </a>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="bg-[#1E2F45]/80 backdrop-blur-md rounded-3xl p-8 w-[380px]">
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-white/30">
                    <i className="ri-shield-check-line text-white text-2xl"></i>
                  </div>
                  <span className="text-white text-base font-medium">Built for regulated environments</span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-white/30">
                    <i className="ri-settings-3-line text-white text-2xl"></i>
                  </div>
                  <span className="text-white text-base font-medium">Designed for real operations</span>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-white/30">
                    <i className="ri-line-chart-line text-white text-2xl"></i>
                  </div>
                  <span className="text-white text-base font-medium">Focused on measurable outcomes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
